<template>
  <div class="page">
    <van-cell-group>
      <!-- <input v-model="name" type="text" placeholder="请输入微信用户名"> -->
      <input v-model="name" readonly type="text" placeholder="请输入用户名" />
      <input v-model="phone" type="text" placeholder="请输入手机号" />
      <div class="code">
        <input v-model="code" type="text" placeholder="请输入短信验证码" />
        <span :class="['getcode', {disable: isGet} ]" @click="getcode">{{tips}}</span>
      </div>
      <input v-model="pwd" type="password" placeholder="请输入密码" />
      <van-button type="primary" round block @click="login">注册</van-button>
    </van-cell-group>
    <p style="position:absolute;bottom:10px;width:100%;text-align:center;"><a style="color:#61dec3" href="https://beian.miit.gov.cn/">闽ICP备20012852号-1</a></p>
  </div>
</template>

<script>
import API from "../utils/api";

export default {
  data: function() {
    return {
      code: "",
      phone: "",
      pwd: "",
      name: "",
      time: 60,
      tips: "获取验证码",
      isGet: false,
      timer: {},
      icon: ""
    };
  },
  methods: {
    login() {
      if (this.phone == "" || this.pwd == "") {
        this.$toast("请输入完整信息");
        return;
      }
      this.$post(
        `${API.userRegister}?name=${this.name}&phone=${this.phone}&pwd=${this.pwd}&code=${this.code}&icon=${this.icon}`
      )
        .then(res => {
          if (res.code == 200) {
            this.$router.push({ path: `login` });
          }else{
            this.$toast(res.msg)
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getcode() {
      if(this.phone == ""){
        this.$toast("请先输入手机号")
        return
      }
      if (!this.isGet) {
        this.isGet = true;
        this.$post(`${API.sms}?phone=${this.phone}`)
          .then(res => {
            if (res.code == 200) {
              this.tips = this.time + "s";
              this.time--;
              this.timer = setInterval(() => {
                if (this.time > 0) {
                  this.tips = this.time + "s";
                  this.time--;
                } else {
                  clearInterval(this.timer);
                  this.tips = "重新获取";
                  this.isGet = false;
                  this.time = 60;
                }
              }, 1000);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    wxAuto() {
      if(sessionStorage.getItem("nickname") != null && sessionStorage.getItem("nickname") != undefined){
        this.name = sessionStorage.getItem("nickname")
        this.icon = sessionStorage.getItem("icon")
        return
      }
      if (this.$route.query.code != "" && this.$route.query.code != undefined) {
        this.$post(`/fn_callback.php?code=${this.$route.query.code}`,{code: this.$route.query.code})
          .then(res => {
            sessionStorage.setItem("nickname", res.nickname)
            sessionStorage.setItem("icon", res.headimgurl)
            sessionStorage.setItem("openid", res.openid)
            this.name = res.nickname
            this.icon = res.headimgurl
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.$post(`/login.php`)
          .then(res => {
            if (res.code == 1) {
              location.href = res.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
  created() {
    this.wxAuto();
  },
  mounted() {},
  computed: {},
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
<style scoped>
.page {
  background: linear-gradient(top, #61dec3, #fff);
  background: url(/static/img/bgindex.png) no-repeat 50%;
  background-size: 100% 100%;
  min-height: 100vh;
  width: 100%;
}
.van-cell-group {
  position: absolute;
  top: 45%;
  left: 5%;
  right: 5%;
  background: none;
}
.van-hairline--top-bottom::after {
  border: none;
}
.van-cell-group input {
  width: 100%;
  background: #fafafa;
  margin-bottom: 20px;
  padding: 0 15px;
  height: 44px;
  line-height: 44px;
  border-radius: 100px;
}
.van-cell-group input::placeholder {
  color: #ccc;
}
.van-cell-group .van-button--primary {
  background-color: #61dec3;
  border: 1px solid #61dec3;
  font-size: 16px;
}
.van-cell-group .code {
  position: relative;
}
.van-cell-group .code input {
  padding-right: 120px;
}
.van-cell-group .code .getcode {
  position: absolute;
  width: 100px;
  height: 34px;
  line-height: 34px;
  top: 5px;
  right: 5px;
  background: #61dec3;
  text-align: center;
  color: #fff;
  border-radius: 100px;
}
.van-cell-group .code .disable {
  background: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/pages/regist.vue